import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store";
import { isTelegramWebApp } from "./utils/helpers";
import { WebAppProvider } from "@vkruglikov/react-telegram-web-app";
import { TonConnectUIProvider } from "@tonconnect/ui-react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

if (isTelegramWebApp()) {
  root.render(
    <Provider store={store}>
      <WebAppProvider
        options={{
          smoothButtonsTransition: true,
        }}
      >
        <TonConnectUIProvider
          manifestUrl="https://playops.tapsphere.io/tonconnect-manifest.json"
          actionsConfiguration={{
            twaReturnUrl: "https://t.me/PlayOpsARGTerminalBot",
          }}
        >
          <App />
        </TonConnectUIProvider>
      </WebAppProvider>
    </Provider>
  );
} else {
  root.render(
    <div className="unsupported">
      <h1>Unsupported browser</h1>
      <p>Please use Telegram Desktop or Telegram Web to access this website.</p>
    </div>
  );
}
